import qs from "qs";
import { useLocation } from "react-router";
import {PASS_SALE, REALIZE_VOUCHER} from "../../app/models/TypeSale";

export default function useTypeSale() {
  const location = useLocation();
  const isSaleWithExerciseString = qs.parse(location.search.slice(1)).isSaleWithExercise as string;
  const isChangeZoneString = qs.parse(location.search.slice(1)).isChangeZone as string;
  const typeSale = qs.parse(location.search.slice(1)).typeSale as string;
  const isExercise = isSaleWithExerciseString === "true";
  const isChangeZone = isChangeZoneString === "true";
  const backgroundClass = isExercise ? "background-second-color" : "background-first-color";
  const categoryBrand = isExercise
    ? "Park Wodny, Park Atrakcji i Wesołe Miasteczko"
    : "Park Atrakcji i Wesołe Miasteczko";

  const getColorClass = (): string => {
    if (typeSale === PASS_SALE) {
      return "third-color";
    }
    if (typeSale === REALIZE_VOUCHER) {
      return "use-pass-color";
    }
    if (isExercise) {
      return "second-color";
    }
    return "first-color";
  };

  return {
    isSaleWithExercise: isExercise,
    backgroundClass,
    colorClass: getColorClass(),
    categoryBrand,
    isChangeZone,
    typeSale
  };
}
